<app-header
  *ngIf="storage.getProfile()"
  [selectedLanguage]="selectedLanguage"
  [languages]="languages"
  [changeLanguage]="changeLanguage.bind(this)"
></app-header>
<p-toast position="bottom-right" *ngIf="!isLoginPage"></p-toast>
<router-outlet></router-outlet>
